import React from 'react';
import { Link } from 'react-router-dom';
import AuthShell from '../components/layout/AuthShell';

export default function DevicePendingPage() {
  return (
    <AuthShell
      title="Device approval pending"
      subtitle="This device must be approved by Success Bridge Academy before you can continue."
    >
      <div style={{ textAlign: 'center', color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
        <span
          className="material-symbols-outlined"
          style={{ fontSize: 48, color: '#4b00d1', display: 'block', marginBottom: 16 }}
        >
          phonelink_lock
        </span>
        <p>
          For your security, new laptops and phones need admin approval. You will receive a notification
          once your device is approved.
        </p>
        <Link to="/" className="sba-auth-btn-primary" style={{ display: 'inline-block', marginTop: 20 }}>
          Return to website
        </Link>
      </div>
    </AuthShell>
  );
}
